export default "__VITE_ASSET__VfYivXSx__"